import { RootState } from "../../Presentation/store";

export const selectAccounts = (state: RootState) => state.account.list;
export const selectAccountLoading = (state: RootState) => state.account.loading;
export const selectSlackNotifySettings = (state: RootState) => state.account.slackNotifySettings;
export const selectSlackNotifyLoading = (state: RootState) => state.account.slackNotifyLoading;
export const selectSlackNotifySaving = (state: RootState) => state.account.slackNotifySaving;
export const selectSlackNotifyError = (state: RootState) => state.account.slackNotifyError;
